App.directive('footerTpl', ['$window', function ($window) {
    return {
        restrict: 'AEC',
        scope: {
        	color: '@'
        },
        templateUrl: 'Templates/footer-tpl.html'
    };
}]);